import { ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const colorList = [
  'background',
  'foreground',
  'body-foreground',
  'secondary',
  'secondary-foreground',
  'border',
  'placeholder',
  'tertiary',
  'tertiary-foreground',
  'input',
  'primary',
  'primary-foreground',
  'primary-no-alpha',
  'accent-foreground',
  'link',
];

export const customTWMerge = extendTailwindMerge({
  override: {
    classGroups: {
      fill: colorList.map((color) => `fill-${color}`),
      'font-size': [
        'text-base-regular',
        'text-base-semibold',
        'text-sm',
        'text-sm-regular',
        'text-sm-medium',
        'text-sm-semibold',
        'text-xs',
        'text-xs-regular',
        'text-xs-semibold',
        'text-xs-medium',
        'text-unicase-sm',
        'text-unicase-lg',
        'text-description-lg',
        'text-description-sm',
        'text-link-lg',
        'text-title-lg',
        'text-title-sm',
        'text-highlight-lg',
        'text-highlight-sm',
      ],
      'text-color': colorList.map((color) => `text-${color}`),
      'font-weight': ['font-regular', 'font-medium', 'font-bold'],
      'bg-color': colorList.map((color) => `bg-${color}`),
      'min-w': ['min-w-full'],
      w: ['w-full', 'w-max', 'w-fit', 'w-auto'],
      display: ['hidden', 'block', 'flex', 'grid', 'inline', 'inline-flex'],
      'font-family': ['font-the-future', 'font-the-future-medium'],
      'border-color': ['border-secondary'],
    },
  },
});

export default function cn(...input: ClassValue[]) {
  return customTWMerge(clsx(...input));
}
